import EmptyImport from './emptyImports.view';

export default EmptyImport;
